import { render } from "./BookReader.vue?vue&type=template&id=046cf3f4&scoped=true"
import script from "./BookReader.vue?vue&type=script&lang=js"
export * from "./BookReader.vue?vue&type=script&lang=js"

import "./BookReader.vue?vue&type=style&index=0&id=046cf3f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046cf3f4"]])

export default __exports__